import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { getCategoryIcon } from '../Layouts/Header/CategoryNav';
import { useLang, catName } from '../../utils/i18n';

// Normalizes any category name to sentence case (first letter capital,
// everything else lowercase) — regardless of how it was originally typed
// or migrated in ("DIWALI PRODUCTS", "Non Alcoholic Beer", etc.).
const toSentenceCase = (str) => {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const CategoryGridFooter = () => {
    const { lang } = useLang();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const { data } = await axios.get('/api/v1/categories');
                setCategories(data.categories);
            } catch (error) {
                console.error('Failed to load categories', error);
            }
        };
        fetchCategories();
    }, []);

    if (categories.length === 0) return null;

    const [featured, ...rest] = categories;
    const gridItems = rest.slice(0, 8);

    return (
        <div className="bg-white rounded-lg border overflow-hidden grid grid-cols-1 sm:grid-cols-5">

            <Link to={`/products?category=${featured.slug}`} className="sm:col-span-1 flex flex-col items-center justify-center gap-3 p-8 border-b sm:border-b-0 sm:border-r hover:bg-gray-50">
                <span className="text-primary-blue">{getCategoryIcon(featured.name, "48px")}</span>
                <span className="font-semibold text-gray-800 text-center">{lang === 'zh' ? catName(featured, lang) : toSentenceCase(featured.name)}</span>
            </Link>

            <div className="sm:col-span-4 grid grid-cols-2 sm:grid-cols-4">
                {gridItems.map((cat) => (
                    <Link
                        key={cat._id}
                        to={`/products?category=${cat.slug}`}
                        className="flex items-center gap-3 p-6 border-b border-r hover:bg-gray-50"
                    >
                        <span className="text-gray-400">{getCategoryIcon(cat.name, "32px")}</span>
                        <span>
                            <span className="block font-medium text-gray-800 text-sm">{lang === 'zh' ? catName(cat, lang) : toSentenceCase(cat.name)}</span>
                        </span>
                    </Link>
                ))}
            </div>

        </div>
    );
};

export default CategoryGridFooter;